import "../style.css";
import { useEffect } from "react";

export const TermsAndCondition = () => {
  
  useEffect(() => {
    // Update canonical tag
    const canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://saddlefit.io/terms-and-conditions');
    }

    // Update meta tags and title
    document.title = 'Terms and Conditions - SaddleFit.io';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Review SaddleFit.io\'s Terms and Conditions to learn about the rules and guidelines for using our platform and services.'
      );
    }
  }, []);

  return (
    <div className="main_container">
      <div className="terms_main">
        <h1 className="term_head">
          Terms and Conditions
        </h1>

        <div className="border_btm"></div>
        <div className="Mb_border_btm"></div>

        <div>
          <h2 className="text_head">Welcome to Saddle Fit:</h2>
          <p className="paragrah_text">
            These terms and conditions govern your use of the Saddle Fit
            software and website.
          </p>

          <h2 className="text_head">Acceptance of Terms:</h2>
          <p className="paragrah_text">
            By using our software and website, you agree to comply with these
            terms.
          </p>

          <h2 className="text_head">User Responsibilities:</h2>
          <p className="paragrah_text">
            Users must provide accurate information during registration.
          </p>
          <p className="paragrah_text">
            Users are responsible for maintaining the confidentiality of their
            account.
          </p>

          <h2 className="text_head">Intellectual Property Rights:</h2>
          <p className="paragrah_text">
            The content, layout, design, data, databases and graphics on this
            website are protected by intellectual property laws.
          </p>
          <p className="paragrah_text">
            Unless explicitly stated, Saddle Fit and/or its licensors own the
            intellectual property rights in the website and material on the
            website.
          </p>

          <h2 className="text_head">Permitted Use:</h2>
          <p className="paragrah_text">
            Users are allowed to use the website and software as intended by
            Saddle Fit.
          </p>
          <p className="paragrah_text">
            Commercial use or redistribution of content, tools, or services
            without express permission is prohibited.
          </p>

          <h2 className="text_head">Restrictions:</h2>
          <p className="paragrah_text">
            Users must not use the website or software in any way that causes,
            or may cause, damage to the website or impairment of the
            availability or accessibility of the service.
          </p>

          <h2 className="text_head">User Content:</h2>
          <p className="paragrah_text">
            Users are responsible for their own content (like saddle listings,
            comments, and profiles).
          </p>
          <p className="paragrah_text">
            Saddle Fit reserves the right to remove any of User’s content at any
            time without notice.
          </p>

          <h2 className="text_head">Privacy and Personal Information:</h2>
          <p className="paragrah_text">
            The user&apos;s personal information will be handled in accordance with
            our Privacy Policy.
          </p>

          <h2 className="text_head">Limitation of Liability:</h2>
          <p className="paragrah_text">
            Saddle Fit will not be liable for any indirect, special or
            consequential loss or damage arising under these terms and
            conditions or in connection with our website, whether arising in
            tort, contract, or otherwise.
          </p>

          <h2 className="text_head">Breach of Terms and Conditions:</h2>
          <p className="paragrah_text">
            If you breach these terms and conditions, Saddle Fit may take such
            action as deemed appropriate to deal with the breach.
          </p>

          <h2 className="text_head">Revision of Terms:</h2>
          <p className="paragrah_text">
            Saddle Fit reserves the right to revise these terms and conditions
            from time to time.
          </p>

          <h2 className="text_head">Governing Law & Jurisdiction:</h2>
          <p className="paragrah_text">
            These terms will be governed by and construed in accordance with the
            laws of the jurisdiction in which Saddle Fit operates, and any
            disputes relating to these terms and conditions will be subject to
            the exclusive jurisdiction of the courts of this jurisdiction.
          </p>
        </div>
      </div>
    </div>
  );
};
